import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	commsTabTourHeading: {
		id: 'communications-stakeholders.changeboarding.commsTabTour.heading',
		defaultMessage: 'You can now manage your incident communications directly from your site.',
		description: 'Label for the comms tab tour header in the changeboarding',
	},
	commsTabTourBody: {
		id: 'communications-stakeholders.changeboarding.commsTabTour.body',
		defaultMessage:
			'For any incident or maintenance, keep your stakeholders in the loop during every milestone to build lasting trust.',
		description: 'Label for the comms tab tour body in the changeboarding',
	},
	commsTabTourAction: {
		id: 'communications-stakeholders.changeboarding.commsTabTour.action',
		defaultMessage: 'Next',
		description: 'Label for the comms tab tour action in the changeboarding',
	},
	commsTabTourDismissIconLabel: {
		id: 'communications-stakeholders.changeboarding.commsTabTour.dismissIconLabel',
		defaultMessage: 'Close',
		description: 'Label for the dismiss icon in the comms tab tour',
	},
	commsTabTourMediaAltText: {
		id: 'communications-stakeholders.changeboarding.commsTabTour.mediaAltText',
		defaultMessage: 'Communications',
		description: 'Alt text for the comms tab tour media',
	},
});
